// extracted by mini-css-extract-plugin
module.exports = {"modal_footer":"beschikbare-notarissen_modal_footer__3NGlP"};